export default __webpack_public_path__ + "static/739-e8dd524f5bcd94867bb87cae1aef7059.gif";